module.exports = __webpack_public_path__ + "static/img/Death.4965032.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobiscope/imgs/tarot_image/Death.jpg
// module id = 1260
// module chunks = 0